angular.module('eatself').directive('responsiveClass',function() {
    let breakpoints = {
        xs: 340,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400,
    };
    let usedSelectors = {};
    let stylesheet = null;
    
    function getCSSProperties(selector) {
        for(let i in document.styleSheets) {
            for(let j in document.styleSheets[i].cssRules) {
                if (document.styleSheets[i].cssRules[j].selectorText == selector) {
                    return document.styleSheets[i].cssRules[j].cssText.split('{ ')[1].split(' }')[0];
                }
            }
        }
        return null;
    }
    
    return {
        restrict: 'A', 
        link($scope, $element, $attrs) {
            let classes = $attrs.responsiveClass.split(' ');
            for(let i in classes) {
                let [breakpoint, classname] = classes[i].split(':');
                if (!classname) {
                    $element.addClass(classes[i]);
                } else {
                    if (!usedSelectors[classes[i]]) {
                        let width = breakpoints[breakpoint];
                        if (!width) {
                            console.error('breakpoint is not defined',breakpoint);
                        }
                        let cssProps = getCSSProperties(`.${classname}`);
                        if (!cssProps) {
                            console.error('no properties found for',classname);
                        }
                        cssProps = cssProps.split('; ').join(';\n\t\t');
                        let definition = 
                          `@media (min-width: ${width}px) { \n` 
                        + `\t.${breakpoint}--${classname} {\n` 
                        + `\t\t${cssProps}\n`
                        + `\t}\n`
                        + `}\n\n`;
                        if (!stylesheet) {
                            let el = document.createElement('style');
                            el.setAttribute('type','text/css');
                            el.setAttribute('id','responsive-class-stylesheet');
                            document.head.appendChild(el);
                            // stylesheet = document.styleSheets[document.styleSheets.length - 1];
                            stylesheet = el;
                        }
                        // stylesheet.insertRule(definition, stylesheet.cssRules.length);
                        stylesheet.innerHTML += definition;
                        usedSelectors[classes[i]] = true;
                    }
                    $element.addClass(`${breakpoint}--${classname}`);
                }
            }
        }
    }
})